export const NAME = 'mailroomReceivedList';